import React, { Fragment, useEffect, useMemo } from 'react';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import cn from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { get } from 'lodash';

import Header from 'components/Header';
import Footer from 'components/Footer';
import { Grid, Column } from 'components/Layout';
import { Button } from 'components/Button';

import {
  checkPreviousAction,
} from 'actions/workflow';

import CircleDeclined from 'assets/icons/circle-declined.svg';
import style from './style.scss';

const GeneralErrorPage = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const params  = useParams();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const workflow = useSelector((state) => state.workflow);
  const errorMessage = useMemo(() => ((get(location, 'data.data.errorMessages') && get(location, 'data.data.errorMessages').length) ? get(location, 'data.data.errorMessages').join(',') : ''), [location]);

  useEffect(() => {
    const key = searchParams.get('key');
  
    if (key) {
      !get(workflow, 'data') && dispatch(checkPreviousAction({
        data: {},
        url: `/workflows/fsl/${key}/checkin`,
        success: (response) => {
          const routeUrl = response.data && response.data.url;
          navigate(routeUrl);
        },
        fail: () => {
          navigate('/fsl/application', { replace: true });
        },
      }));
    } else {
      navigate('/fsl/application', { replace: true });
    }
  }, []);

  const handleMerchantReturnClick = (e) => {
    const pid = searchParams.get('pid');
    const key = searchParams.get('key');
    e.preventDefault();
    if (pid) {
      navigate(`/fsl/applications/${params.workflowtype}/application/?pid=${pid}`);
    } else {
      navigate(`/fsl/applications/?key=${key}`);
    }
  };

  return (
    <Fragment>
      <Header />
      <section className={cn('grid-container fluid section', style['borrowers-apply'])}>
        <div className="grid-container fluid borrowers-message">
          <div className="grid-container">
            <Grid className="grid-margin-x max-limited">
              <Column className="small-12 large-10 large-offset-1">
                <img src={CircleDeclined} alt="circle declined" />
                <h2>Unfortunately, we were unable to approve your application at this time</h2>
                {
                  errorMessage &&
                    <p className="p-xlarge error text-center mb-2">{errorMessage}</p>
                }
                {
                  localStorage.getItem('token') && (
                    <Button
                      className="large arrow buttonStyle"
                      onClick={handleMerchantReturnClick}
                      color="primary"
                    >
                      Try again
                    </Button>
                  )
                }
              </Column>
            </Grid>
          </div>
        </div>
      </section>
      <div className={cn('grid-container fluid section', style.message)}>
        <Grid className="grid-margin-x max-limited">
          <Column className="small-12 large-10 large-offset-1">
            <p className="p-xlarge">You will receive an adverse action notice within 30 days that will provide you with the specific reason(s) as to why we were unable to approve your application [{params.key}].</p>
          </Column>
        </Grid>
      </div>
      <Footer />
    </Fragment>
  );
};

export default GeneralErrorPage;
